import { Badge, styled, BadgeProps } from '@mui/material';

const StyledSideBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    position: 'relative',
    transform: 'none',
    marginLeft: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

export default StyledSideBadge;
